export default "/corgi/pageapps/purchase/_next/static/media/arrow-down.6fa3d6c8.svg";